import Password from './password.vue'

export default {
  name: 'password',
  path: '/accounts/password/:token',
  component: Password,
  meta: {
    secure: false,
    reCaptcha: true
  }
}
